import React from 'react';
import {Container, Row, Col} from "react-bootstrap";
// import emailjs from '@emailjs/browser';

function Footer () {

    return (
        <Container>
            <h4 style={{textAlign: 'center'}}>Our Location</h4>
            <iframe
                src={'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2805.5380831624975!2d-93.19294994866307!3d45.31775575112138!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x52b3197a3e461697%3A0xcbfb1e9abc348751!2sHome%20Safety%20Solutions%20Inc!5e0!3m2!1sen!2sus!4v1676052346659!5m2!1sen!2sus'}
                // width="600"
                width={'100%'}
                // height="450"
                height={'450'}
                // style="border:0;"
                style={{border:'0'}}
                // allowFullScreen=""
                allowFullScreen={''}
                // loading="lazy"
                loading={'lazy'}
                // referrerPolicy="no-referrer-when-downgrade"
                referrerPolicy={'no-referrer-when-downgrade'}
                title={"Visit Us"}
            />
            <br /> <br /><br />


            {/*<Row className={"WaltHenry"}>*/}
            {/*    <h2 style={{textAlign: 'center'}}>*/}
            {/*        Who You'll Talk To*/}
            {/*    </h2>*/}
            {/*    <p style={{textAlign: 'center'}}>*/}
            {/*        When calling Home Safety Solutions we dont believe in having our customers talk to a nameless,*/}
            {/*        faceless person who could be half around the world, or a machine that wastes time.*/}
            {/*        Meet our sales team who will answer your phone call.*/}
            {/*    </p>*/}


            {/*        <Col style={{borderStyle: 'solid', borderColor: 'lightgray', borderRadius: '25px', margin: '2px', paddingTop:'14px', paddingBottom: "15px", textAlign: 'left'}}>*/}
            {/*            <img*/}
            {/*                // style={{display:'block', marginLeft: 'auto', marginRight: 'auto', width: 'auto', height: '50%'}}*/}
            {/*                src={'thingOne.PNG'}*/}
            {/*                alt={'walt'}*/}
            {/*                className={"landingPagePics"}*/}
            {/*            />*/}
            {/*            <h6>Walt</h6>*/}
            {/*            <p>*/}
            {/*                Walt has been a Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod*/}
            {/*                tempor incididunt ut labore et dolore magna aliqua. Lacinia quis vel eros donec ac odio.*/}
            {/*            </p>*/}
            {/*        </Col>*/}

            {/*        <Col style={{borderStyle: 'solid', borderColor: 'lightgray', borderRadius: '25px', margin: '2px', paddingTop:'14px', paddingBottom: "15px", textAlign: 'right'}}>*/}
            {/*            <h6>Henry</h6>*/}
            {/*            <p>*/}
            {/*                Henry has been with Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod*/}
            {/*                tempor incididunt ut labore et dolore magna aliqua. Nulla facilisi nullam vehicula ipsum a.*/}
            {/*            </p>*/}

            {/*            <img*/}
            {/*                // style={{display:'block', marginLeft: 'auto', marginRight: 'auto', width: 'auto', height: '50%'}}*/}
            {/*                className={"landingPagePics"}*/}
            {/*                src={'thingTwo.PNG'}*/}
            {/*                alt={"Henry"}*/}
            {/*            />*/}
            {/*        </Col>*/}

            {/*</Row>*/}

            {/*<br /> <br /><br />*/}

            <Row>
                <Col className={"text-left py-3"}>
                    MEMBERS OF:
                    <br />
                    • AARST (American Association of Radon Scientists and Technologists)
                    <br />
                    • Builder's Association of Minnesota
                    <br />
                    • National Association of Realtors
                    <br />
                    • Indoor Air Quality Association
                    <br />
                    • Minnesota Multifamily Association
                    <br />
                    • Minnesota Society of Home Inspectors
                    <br />
                    • VOC contractors for the US EPA St. Louis Park projects
                </Col>


                <Col style={{textAlign: 'right'}} className={"py-3"} >
                    Copyright &copy; Home Safety Solutions
                    < br />
                    HSS is a woman-owned company
                    < br />
                    Lic. # BC630387
                </Col>
            </Row>
        </Container>
    )
}

export default Footer